import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import TEXT from "../../../../utils/globalText";
import SingleSelectDropDownComponent from "../../../_utils/CommonDropdown/SingleSelectDropdown";
import TextInputField from "../../../_utils/CommonInputFields/TextInputField";
import "./index.css";
import ICONS from "../../../../assets/Icons";

const SelectServiceProvider = ({
  providerOpen,
  setProviderOpen,
  serviceSelected,
  setServiceSelected,
  credentials,
  setCredentials,
  credentialsFocus,
  setCredentialsFocus,
  handleServiceProvider,

  fetchCloudKeysError,
  setBankingSelected,
  setSelectKey,

  fetchNewCloudKeysError,
  isRotatingKeys,
  isUpdateKey,
}) => {
  const providerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isRotatingKeys || isUpdateKey) {
      setServiceSelected("AWS");
    }
    const handleClickOutside = (event) => {
      if (providerRef.current && !providerRef.current.contains(event.target)) {
        setProviderOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex Qlg:flex-row flex-col flex-wrap w-full items-start gap-gap-xl pb-[var(--mobile-create-header)] pt-padding-lg overflow-hidden">
      <div class="Qlg:flex-1 w-full">
        <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md h-full">
          <h3 className="text-text-primary text-font-md font-semibold mb-margin-md">
            {TEXT?.SERVICE_PROVIDER}
          </h3>
          <SingleSelectDropDownComponent
            options={["AWS"]}
            placeholder="Select security server"
            selected={serviceSelected}
            setSelected={setServiceSelected}
            type="big"
          />
          {serviceSelected && (
            <div className="service-provider-warning">
              <h3 className="service-provider-warning-top-head font-normal text-font-sm text-text-primary">
                {TEXT?.RETRIEVE_KEY}
              </h3>
              <div className="service-provider-warning-1">
                <h4 className="font-sans font-normal text-font-xs text-text-secondary mb-margin-sm">
                  {TEXT?.LOGIN_IAM_HINT}
                </h4>
                <img
                  src={ICONS?.ACCESS_PORTAL}
                  alt="service-warn"
                />
              </div>
              <div className="service-provider-warning-2">
                <h4 className="font-sans font-normal text-font-xs text-text-secondary mb-margin-sm">
                  {TEXT?.COPY_AWS_FIELDS_INSTRUCTION}
                </h4>
                <img
                  src={ICONS?.GET_CREDENTIALS}
                  alt="service-warn"
                />
              </div>
              <h3 className="font-sans font-normal text-font-xs text-text-secondary service-provider-warning-top-bottom">
                {TEXT?.REFERENCE_IMAGES_NOTE}
              </h3>
            </div>
          )}
        </div>
      </div>

      <div
        class="Qlg:flex-1 w-full"
        style={{
          visibility: serviceSelected ? "visible" : "hidden",
          paddingBottom: serviceSelected ? "var(--padding-md)" : "",
        }}
      >
        <div className="flex flex-col gap-gap-md">
          <div className="flex flex-col gap-gap-md bg-primary-card p-padding-md rounded-border-radius-md">
            <h2 className="text-text-primary text-font-md font-semibold">
              {TEXT?.ENTER_AWS_CREDENTIALS}
            </h2>
            <div className="flex flex-col gap-gap-md w-full">
              <TextInputField
                placeholder={TEXT?.SSO_REGION}
                variant={
                  fetchCloudKeysError || fetchNewCloudKeysError
                    ? "error"
                    : "default"
                }
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={credentials?.region}
                name="region"
                fontKind="big"
                isDisabled={false}
                isFullWidth={true}
                onInput={(e) => handleServiceProvider(e)}
              />

              <TextInputField
                placeholder={TEXT?.AWS_ACCESS_KEY_ID}
                variant={
                  fetchCloudKeysError || fetchNewCloudKeysError
                    ? "error"
                    : "default"
                }
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={credentials?.access_key}
                name="access_key"
                fontKind="big"
                isDisabled={false}
                isFullWidth={true}
                onInput={(e) => {
                  handleServiceProvider(e);
                }}
              />

              <TextInputField
                placeholder={TEXT?.AWS_SECRET_ACCESS_KEY}
                variant={
                  fetchCloudKeysError || fetchNewCloudKeysError
                    ? "error"
                    : "default"
                }
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={credentials?.secret_access_key}
                name="secret_access_key"
                fontKind="big"
                isDisabled={false}
                isFullWidth={true}
                onInput={(e) => {
                  handleServiceProvider(e);
                }}
              />

              <TextInputField
                placeholder={TEXT?.AWS_SESSION_TOKEN}
                variant={
                  fetchCloudKeysError || fetchNewCloudKeysError
                    ? "error"
                    : "default"
                }
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={credentials?.session_token}
                name="session_token"
                fontKind="big"
                isDisabled={false}
                isFullWidth={true}
                onInput={(e) => {
                  handleServiceProvider(e);
                }}
              />
            </div>
          </div>

          <div className="flex items-center gap-gap-md bg-emphasis p-padding-md rounded-border-radius-md">
            <img
              src={
                "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
              }
              alt="warning"
              className="w-icon-md h-icon-md"
            />
            <div className="flex flex-col gap-gap-sm">
              <h4 className="text-text-primary text-font-sm font-normal">
                {TEXT?.SESSION_TOKEN_EXPIRES}
              </h4>
              <p className="text-text-secondary text-font-xs font-normal">
                {TEXT?.TOKEN_EXPIRY_VARIANT}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectServiceProvider;
